import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "lock",
  "use": "lock-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lock\"><title>icn/lock</title><path d=\"M5 5a3 3 0 1 1 6 0v1a2 2 0 0 1 2 2v3a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a2 2 0 0 1 2-2V5zm2 0v1h2V5a1 1 0 1 0-2 0zM5 8v3a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V8H5z\" id=\"lock_a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol